module.exports = __webpack_public_path__ + "static/media/mail_outline.4dc7a8cc.svg";